import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SalaryModel } from './salary.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Observable } from "rxjs";
import { UntypedFormControl } from '@angular/forms';
import { CoreComponent } from '../../../core/header/core.component';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActualSelected, Utils } from '../../../shared/utils';
import { EmployeesListModel } from '../../employees/employees-list.model';
import { EmployeesListService } from '../../employees/employees-list.service';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { SalaryService } from './salary.service';
import { ActivityService } from '../../user/activity/activity.service';
import { SalaryClassificationService } from './salary-classification.service';
import { CompanyModeService } from '../../../services/company-mode.service';

@Component({
    selector: 'convfact-salary-form',
    templateUrl: './salary-form.component.html',
    styleUrls: ['./salary.component.css'],
    standalone: false
})

export class SalaryFormComponent implements OnInit {

  @Input() salary: SalaryModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;

  showQR: boolean = false;
  ready: boolean = false;

  selectedFile: File | null = null;

  employeesListModel: EmployeesListModel[] = [];
  employeesControl = new UntypedFormControl();
  employeesfilteredOptions: Observable<EmployeesListModel[]>;

  public saved: boolean = false;

  readonly conceptSuggestions: string[] = [
    'Nómina Enero', 'Nómina Febrero', 'Nómina Marzo', 'Nómina Abril',
    'Nómina Mayo', 'Nómina Junio', 'Nómina Julio', 'Nómina Agosto',
    'Nómina Septiembre', 'Nómina Octubre', 'Nómina Noviembre', 'Nómina Diciembre',
  ];
  filteredConceptSuggestions: string[] = [];

  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;

  // Clasificador de gastos (subpartida, siempre bajo "1. Gastos de personal") - solo asociaciones/fundaciones
  clasificadorSubpartidas: string[] = [];

  constructor(
    public snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private core: CoreComponent,
    private salaryService: SalaryService,
    private employeesListService: EmployeesListService,
    private masterService: MasterService,
    private activityService: ActivityService,
    private salaryClassificationService: SalaryClassificationService,
    public companyModeService: CompanyModeService
  ) { }

  ngOnInit() {
    this.ready = false;
    this.clasificadorSubpartidas = this.salaryClassificationService.getSubpartidas();

    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
          this.isProjectEnable = activity.isProject;
        });

    this.employeesListService.getList().then(
      employees => {
        this.employeesListModel = employees.filter(e => e.active !== false);
        this.ready = true;
      });

    this.employeesfilteredOptions = this.employeesControl.valueChanges.pipe(
      startWith(''),
      debounceTime(100),
      distinctUntilChanged(), // Asegura que el valor sea diferente antes de continuar
      map(value => this._filter(value))
    );

     //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects=data;
      this.cdr.detectChanges();
    })

    //Expense Project Types
    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes=data;
      this.cdr.detectChanges();
    })
  }

  private _filter(value: string): EmployeesListModel[] {
    if (!value) return this.employeesListModel;
    const normalizedValue = this.normalize(value);
    return this.employeesListModel.filter(option => this.normalize(option.name).includes(normalizedValue));
  }

  // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  private normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public setEmployeeIdentifier(selectedEmplooyeId: number) {
    this.salary.employee_Id = selectedEmplooyeId;
  }

  public save(salary): void {
    let noError = true;

    if (!Utils.DateIsInFiscalYear(salary.date)) {
      noError = false;
      this.displayInfo("La fecha y el año fiscal seleccionado, no son el mismo.");
    }

    if (this.salary.employee_Id == null || this.salary.employee_Id == 0) {
      noError = false;
      this.displayInfo("Tiene que seleccionar un empleado a la nomina.");
    }

    if (isNaN(this.salary.otherDeductions)) {
      this.salary.otherDeductions = 0;
    }

    if (isNaN(this.salary.segSocialWorker)) {
      this.salary.segSocialWorker = 0;
    }

    if (isNaN(this.salary.advancePayments)) {
      this.salary.advancePayments = 0;
    }

    if (isNaN(this.salary.segSocialCompany)) {
      this.salary.segSocialCompany = 0;
    }

    if (noError) {
      this.salary.activityUid = this.core.activitySelected;
      this.salary.fiscalYear = this.core.yearSelected;
       salary.projectUid = this.salary.projectUid;
       salary.expenseProjectTypeUid = this.salary.expenseProjectTypeUid;
       salary.clasificadorSubpartida = this.salary.clasificadorSubpartida;
      this.onSave.emit({ salary, file: this.selectedFile });
    }
  }

  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (file) {
      this.selectedFile = file;
    }
  }

  public removeSelectedFile(): void {
    this.selectedFile = null;
  }

  public onFocusSalaryNet(): void {

    let salaryBrutValue = Number(this.salary.salaryBrut);
    let salaryInKindValue = Number(this.salary.salaryInKind);
    let irpfValue = Number(this.salary.irpf);
    let irpfnKindValue = Number(this.salary.irpfnKind);
    let segSocialWorkerValue = Number(this.salary.segSocialWorker);
    let otherDeductionsValue = Number(this.salary.otherDeductions);
    let advancePaymentsValue = Number(this.salary.advancePayments);

    let paymentsForIncapacityForWork = Number(this.salary.paymentsForIncapacityForWork);
    let exemptSalary = Number(this.salary.exemptSalary);
    let exemptSalaryInKind = Number(this.salary.exemptSalaryInKind);
    let personalIncomeTaxOnPaymentsForIncapacityForWork = Number(this.salary.personalIncomeTaxOnPaymentsForIncapacityForWork);

    if (isNaN(salaryBrutValue)) {
      salaryBrutValue = 0;
    }

    if (isNaN(salaryInKindValue)) {
      salaryInKindValue = 0;
    }

    if (isNaN(irpfValue)) {
      irpfValue = 0;
    }

    if (isNaN(irpfnKindValue)) {
      irpfnKindValue = 0;
    }

    if (isNaN(segSocialWorkerValue)) {
      segSocialWorkerValue = 0;
    }

    if (isNaN(otherDeductionsValue)) {
      otherDeductionsValue = 0;
    }

    if (isNaN(paymentsForIncapacityForWork)) {
      paymentsForIncapacityForWork = 0;
    }

    if (isNaN(exemptSalary)) {
      exemptSalary = 0;
    }

    if (isNaN(exemptSalaryInKind)) {
      exemptSalaryInKind = 0;
    }

    if (isNaN(advancePaymentsValue)) {
      advancePaymentsValue = 0;
    }

    if (isNaN(personalIncomeTaxOnPaymentsForIncapacityForWork)) {
      personalIncomeTaxOnPaymentsForIncapacityForWork = 0;
    }

    const result =
      salaryBrutValue + salaryInKindValue -
      irpfValue - irpfnKindValue - segSocialWorkerValue - otherDeductionsValue - advancePaymentsValue +
      paymentsForIncapacityForWork + exemptSalary + exemptSalaryInKind -
      personalIncomeTaxOnPaymentsForIncapacityForWork;

    this.salary.salaryNet = Utils.GetValueWithDecimals(result);

  }

  onConceptInput(value: string): void {
    const v = (value || '').toLowerCase();
    this.filteredConceptSuggestions = v
      ? this.conceptSuggestions.filter(s => s.toLowerCase().includes(v))
      : this.conceptSuggestions;
  }

  onConceptFocus(): void {
    if (!this.filteredConceptSuggestions.length) {
      this.filteredConceptSuggestions = [...this.conceptSuggestions];
    }
  }

  public trackByIndex(i: number) { return i; }

}
